<!-- TODO: This component should be refactored in that way, that we directly
listing charts, not using wrapper component like atn-mosaic-chart-donut,
atn-mosaic-chart-bar etc. With this change, we will accomplish less code for
calculating rows and columns for grid structure in css, for each chart. Current
issue that would be caused with those changes, is that chart in design is
not refreshing after changing chart type. 
-- EXAMPLE: when we are in widget dialog, current chart type in query editor is
'line', we change it to be 'scatter', and click on Run query button, but nothing
happens, design view is not changed from line to scatter chart.-->

@let chartsIfBar = chartsIfBarSg();
@let chartsIfDonut = chartsIfDonutSg();
@let chartsIfLine = chartsIfLineSg();
@let chartsIfScatter = chartsIfScatterSg();
@let chartsIfStackedBar = chartsIfStackedBarSg();
@let chartsIfSunburst = chartsIfSunburstSg();
@let chartsIfVenn = chartsIfVennSg();

@if (chartsIfBar) {
  <atn-mosaic-chart-bar [charts]="chartsIfBar" />
} @else if (chartsIfDonut) {
  <atn-mosaic-chart-donut [charts]="chartsIfDonut" />
} @else if (chartsIfLine) {
  <atn-mosaic-chart-line [charts]="chartsIfLine" />
} @else if (chartsIfScatter) {
  <atn-mosaic-chart-scatter [charts]="chartsIfScatter" />
} @else if (chartsIfStackedBar) {
  <atn-mosaic-chart-bar [charts]="chartsIfStackedBar" />
} @else if (chartsIfSunburst) {
  <atn-mosaic-chart-sunburst [charts]="chartsIfSunburst" />
} @else if (chartsIfVenn) {
  <atn-mosaic-chart-venn [charts]="chartsIfVenn" />
}
